import store from '@/store'
import contentTreeStore from '@/store/modules/contentTree.store'

export default async to => {
  if (!to.meta.requiresContentTree) {
    return
  }

  if (contentTreeStore.state.isLoaded) {
    return
  }

  await new Promise(resolve => {
    const unwatch = store.watch(
      state => state.contentTree.isLoaded,
      loaded => {
        if (loaded) {
          unwatch()
          resolve()
        }
      }
    )
    if (contentTreeStore.state.isLoaded) {
      unwatch()
      resolve()
    }
  })
}
